import { instance, ServiceResponse } from './Axios';

export const getSkills = async (params: { page: number; count: number; name?: string }) => {
  const response = await instance.get<ServiceResponse<Skill[]>>(`/skills/getSkills`, { params });
  return response.data;
};

export const editSkill = async (params: { id: string; name: string }) => {
  const response = await instance.put(`/skills/update`, params);
  return response.data;
};

export const deleteSkill = async (params: { id: string }) => {
  const response = await instance.delete(`/skills/delete`, { params });
  return response.data;
};

export const createSkill = async (params: { name: string }) => {
  const response = await instance.post(`/skills/create`, params);
  return response.data;
}


